import { z } from 'zod';
export const researchNotePatchSchema = z.object({
    ownerNote: z.string().max(2000),
});
//# sourceMappingURL=research.js.map